<template>
  <div>
    <div class="product-item" v-for="item in list" :key="item.id">
      <p class="item-tip">
        <span v-if="item.termCondition">{{item.termCondition}}</span>
        <span v-if="item.priceCondition">注: {{item.priceCondition}}</span>
      </p>
      <div class="left-side">
        <a @click="goToDetail(item)">
          <van-image class="product-img" :src="item.mobileBanner"/>
          <div class="label" v-if="item.promotionImage">
            <img class="label-img" :src="item.promotionImage" />
          </div>
        </a>
      </div>
      <div class="right-side">
        <a @click="goToDetail(item)">
          <p class="product-name el2">{{item.name}}</p>
          <p class="product-info el2">{{item.descriptionShort}}</p>
          <div :class="['price', {'new-line': item.priceUnit.length > 6}]">
            <p><span>{{priceDiscountedFormat(item)}}</span>{{hasBindTicket && (item.priceByRouteDays || item.priceByRouteNights) ? '美元/航次' : item.priceUnit}}</p>
            <p class="old-price" v-if="priceFormat(item) && priceFormat(item) !== priceDiscountedFormat(item)">{{priceFormat(item)}}{{hasBindTicket && (item.priceByRouteDays || item.priceByRouteNights) ? '美元/航次' : item.priceUnit}}</p>
          </div>
          <p class="info-info">{{item.applyTo}}</p>
        </a>
        <a class="btn-common small item-btn btn-detail" @click="goToDetail(item)">
          <img class="icon" src="../../assets/icons/icon_add.png" alt="">
          查看详情
        </a>
        <a href="javascript:;" class="btn-common small item-btn btn-cart" @click="handleBooking(item)">
          <img class="icon" src="../../assets/icons/icon_cart.png" alt="">
          立即预订
        </a>
      </div>
    </div>
    <!-- 预定弹框 -->
    <dialog-booking :visible.sync="bookingShow" :goodsInfo="currentProduct"/>
  </div>
</template>

<script>
import DialogBooking from '@/views/DialogBooking'
import pick from 'lodash/pick'
import { showAlert } from '@/utils/tools'
import { checkOrderState, gioTracking } from '@/plugins/common'
import { mapState } from 'vuex'

export default {
  name: 'ProductList',

  components: {
    DialogBooking
  },

  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    category: {
      type: String,
      default() {
        return ''
      }
    }
  },

  data () {
    return {
      bookingShow: false,
      currentProduct: {}
    }
  },

  computed: {
    ...mapState(['bindTicket']),
    hasBindTicket () {
      return Boolean(this.bindTicket)
    }
  },

  methods: {
    priceDiscountedFormat (current) {
      const calcResult = current.priceDiscounted - current.priceDiscountedServiceCharge
      return calcResult % 1 === 0 ? calcResult : calcResult.toFixed(2)
    },
    priceFormat (current) {
      const calcResult = current.price - current.priceServiceCharge
      return calcResult % 1 === 0 ? calcResult : calcResult.toFixed(2)
    },
    handleBooking (current) {
      checkOrderState(checkResult => {
        if (checkResult) {
          if (checkResult !== 'cancel') showAlert(checkResult)
        } else {
          this.currentProduct = {
            ...pick(current, ['id', 'mobileBanner', 'name', 'applyTo', 'needSync']),
            subcategroy: current.subCategoryName,
            categoryName: this.category
          }
          this.bookingShow = true
        }
      })
    },
    goToDetail (item) {
      gioTracking('track','evt_prdClick', {'productID': item.id,'Product_Category': this.category,'Product_DetailProduct': item.name })
      this.$router.push(`/Rccl.PCP/product/detail/${item.id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.product-item {
  display: flex;
  position: relative;
  padding: 20px 20px 36px 20px;
  margin-bottom: 20px;
  background-color: #fff;
  .left-side {
    flex: 0;
    width: 305px;
    padding-right: 30px;
    .product-img {
      display: block;
      width: 305px;
    }
    .label {
      padding-top: 12px;
      .label-img {
        display: block;
        height: 30px;
        margin-right: 6px;
      }
    }
  }
  .right-side {
    .product-name {
      margin-top: 3px;
      font-size: 26px;
      color: @main-color;
      line-height: 38px;
      font-weight: bold;
    }
    .product-info {
      margin-top: 3px;
      font-size: 20px;
      line-height: 30px;
      color: @main-gray3;
    }
    .price {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      width: 275px;
      margin-top: 16px;
      font-size: 20px;
      color: @main-gray4;
      line-height: 44px;
      span {
        font-size: 32px;
        font-weight: bold;
        color: @second-color;
      }
      .old-price {
        text-decoration: line-through;
      }
      &.new-line {
        flex-wrap: wrap;
        .old-price {
          width: 100%;
        }
      }
    }
    .info-info {
      margin-bottom: 24px;
      font-size: 20px;
      color: @main-gray4;
    }
    .item-btn {
      width: 156px;
      height: 46px;
      margin: 10px 0 0 0;
      border-radius: 6px;
      .icon {
        margin-right: 10px;
      }
      &.btn-detail {
        color: #fff;
        background: #1174b8;
        .icon {
          width: 14px;
        }
      }
      &.btn-cart .icon {
        width: 21px;
      }
    }
  }
  .item-tip {
    position: absolute;
    left: 20px;
    bottom: 30px;
    z-index: 1;
    font-size: 20px;
    color: @main-gray4;
    span {
      display: block;
    }
  }
}
</style>
